/**文本回复的字段 */
import { BaseModel } from '../BaseModel';

export  class WXText extends BaseModel{ 
        TextId:number=0 
        Type:number=1
        Contents:string=""
        Keyword:string=""
        State:number=1  
}